import React from "react";
import { newLogo } from "../../assets/Images";
import { Link } from "react-router-dom";

export default function LibraryRow({ title }) {
  const cards = Array.from({ length: 6 }, (_, i) => ({
    id: i + 1,
    title: "Coming Soon",
  }));

  return (
    <div className="w-full max-w-6xl mx-auto px-6 py-6 select-none">
      {/* Row Header */}
      <div className="flex items-center justify-between mb-6">
        <h3 className="text-xl sm:text-2xl md:text-3xl font-bold font-oswald text-white uppercase tracking-wide border-l-4 border-secondary pl-3">
          {title}
        </h3>
        <Link
          to="/ProductCollection"
          className="text-secondary hover:text-white font-outfit text-xs sm:text-sm md:text-base font-semibold transition-colors flex items-center gap-1"
        >
          View More <span className="text-base font-light">&rarr;</span>
        </Link>
      </div>

      {/* Grid of 6 Portrait Cards */}
      <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-6 gap-4">
        {cards.map((card) => (
          <div
            key={card.id}
            className="group relative aspect-[2/3] bg-black/90 rounded-lg overflow-hidden border border-neutral-800/80 hover:border-secondary/40 shadow-md hover:shadow-secondary/5 transition-all duration-300 cursor-pointer flex flex-col items-center justify-center p-4 hover:scale-105"
          >
            <div className="absolute inset-0 bg-gradient-to-b from-transparent via-black/10 to-black/90 opacity-60"></div>

            <img
              src={newLogo}
              alt="BAB Logo"
              className="object-contain h-4/5 w-4/5 mb-1 transition-transform duration-500 group-hover:scale-110"
            />

            <span className="text-white font-oswald text-[10px] md:text-base tracking-wider uppercase relative z-10 font-bold opacity-80 group-hover:opacity-100 transition-opacity">
              {card.title}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
}
